import {
    createRemoteComponent,
    createRequires
} from "@fishx/remote-component";
import { resolve } from "./remote-component.config.js";

const requires = createRequires(resolve); 
export const RemoteComponent = createRemoteComponent({ requires });
